import React, { FC, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import autosize from 'autosize';
import { commonInputToFastField } from 'src/utils/formik/commonInputToFastField';
import { Input, InputProps } from 'src/components/common/Input';

export type TextareaProps = InputProps & {
  as?: 'textarea';
  rows?: number;
};

const TextareaWrapper = styled.div<{
  $placeholderVariant?: InputProps['placeholderVariant'];
}>`
  textarea {
    resize: none;
    height: auto;
    line-height: 1.5;
    max-height: 100px;
  }
  label {
    cursor: text;
    ${(props) =>
      props.$placeholderVariant === 'hide' &&
      css`
        margin-top: 10px;
      `};
    height: auto;
    padding-bottom: 10px;
  }
  ${(props) =>
    props.$placeholderVariant == null &&
    css`
      label {
        margin-top: 30px;
      }
      span {
        margin-bottom: 10px;
      }
    `};
`;

export const Textarea: FC<TextareaProps> = ({ className, ...props }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      autosize(ref.current);
    }
  }, [ref]);

  return (
    <TextareaWrapper
      className={className}
      $placeholderVariant={props.placeholderVariant}
    >
      <Input ref={ref} as="textarea" rows={1} {...props} />
    </TextareaWrapper>
  );
};

export const TextareaFormik = commonInputToFastField(Textarea, {
  useTargetValue: true,
});
